"use client";

import { Button } from "@/ui";

export interface CTAGradientBadgeProps {
  badge?: string;
  title?: string;
  subtitle?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

export default function CTAGradientBadge({
  badge = "Limited Time",
  title = "Experience the Chef's Signature Menu",
  subtitle = "Book now to secure your table and taste the season's finest creations.",
  primaryLabel = "Book a Table",
  secondaryLabel = "Explore Menu",
  onPrimaryClick,
  onSecondaryClick,
}: CTAGradientBadgeProps) {
  return (
    <section className="max-w-6xl mx-auto text-center px-6">
      <div className="inline-flex items-center gap-2 bg-gradient-to-r from-black to-black/70 text-white px-4 py-2 rounded-full mb-5">
        <span className="w-2 h-2 rounded-full bg-white" aria-hidden="true" />
        <span className="text-xs font-semibold tracking-wide uppercase">
          {badge}
        </span>
      </div>
      <h3 className="text-4xl md:text-5xl font-bold text-black mb-4">
        {title}
      </h3>
      <p className="text-lg md:text-xl text-black/70 mb-8">{subtitle}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={onPrimaryClick}
          className="rounded-full"
        >
          {primaryLabel}
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="lg"
          onClick={onSecondaryClick}
          className="rounded-full"
        >
          {secondaryLabel}
        </Button>
      </div>
    </section>
  );
}
